// Icon keys must match SubjectService.ICON_REGEX in the backend.
export const ICONS: Record<string, string> = {
  book: '📖',
  calculator: '🧮',
  pencil: '✏️',
  globe: '🌍',
  flask: '🧪',
  music: '🎵',
  palette: '🎨',
  ball: '⚽',
  clock: '⏰',
  star: '⭐',
  heart: '❤️',
  language: '🗣️',
};

export const ICON_KEYS = Object.keys(ICONS);

/** What the teacher sees in the icon list (the keys are technical). */
export const ICON_LABELS: Record<string, string> = {
  book: 'boek',
  calculator: 'rekenmachine',
  pencil: 'potlood',
  globe: 'wereldbol',
  flask: 'reageerbuis',
  music: 'muziek',
  palette: 'palet',
  ball: 'bal',
  clock: 'klok',
  star: 'ster',
  heart: 'hart',
  language: 'taal',
};

export const COLOR_PRESETS = [
  '#8c2f39',
  '#b5651d',
  '#c9a24d',
  '#5b7f4f',
  '#2f6f6a',
  '#3f5f8a',
  '#6b4f8a',
  '#7a5c46',
];

export function iconFor(key: string): string {
  return ICONS[key] ?? ICONS.book ?? '';
}

export { readableOn } from '../theme/contrast';
